<template>
  <div
    class="w-auto d-flex justify-content-between text-info overflow-hidden pt-4"
  >
    <div
      @click="emitClicked(prevPageRequest)"
      class="pointer move-left disable-select"
    >
      <span v-if="prevPageRequest != ''">
        <i class="long arrow alternate left icon m-0"></i>
        {{ "dashboard.back" | i18n }}
      </span>
    </div>
    <div
      @click="emitClicked(nextPageRequest)"
      class="pointer move-right disable-select"
    >
      <span v-if="nextPageRequest != ''">
        {{ "dashboard.next" | i18n }}
        <i class="long arrow alternate right icon m-0"></i>
      </span>
    </div>
  </div>
</template>
<script>
/**
 * @description Permet d'afficher des liens de pagination cliquables
 * @author Samuel Colassin
 * @author Alexandre Gallant
 * @vue-props {String} prevPageRequest - L'url de la requête pour obtenir la page précédente
 * @vue-props {String} nextPageRequest - L'url de la requête pour obtenir la page suivante
 * @vue-data {Boolean} isPageRequested - Si une demande de changement de page a été envoyée
 * @vue-event {String} clicked - Est émis quand on clique sur le bouton
 */
export default {
  name: "Pagination",
  props: {
    prevPageRequest: {
      //https://forum.vuejs.org/t/how-to-allow-null-prop/39259
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    },
    nextPageRequest: {
      //https://forum.vuejs.org/t/how-to-allow-null-prop/39259
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    }
  },
  watch: {
    /**
     * @description Réinitialise la valeur de «isPageRequested»
     */
    prevPageRequest: function() {
      this.isPageRequested = false;
    },
    /**
     * @description Réinitialise la valeur de «isPageRequested»
     */
    nextPageRequest: function() {
      this.isPageRequested = false;
    }
  },
  data() {
    return {
      isPageRequested: false
    };
  },
  methods: {
    /**
     * @description Émet que la composante pagination a été cliquée et envoie le lien correspondant
     * @param {String} requestedPage Le lien de la page demandée
     */
    emitClicked(requestedPage) {
      if (this.isPageRequested) {
        return;
      }
      this.isPageRequested = true;
      this.$emit("clicked", requestedPage);
    }
  }
};
</script>
<style lang="scss">
.pointer {
  cursor: pointer;
}
.arrow {
  width: 18px !important;
}
.move-right {
  transform: translateX(20px);
  transition: all 0.15s ease-in-out;
}
.move-left {
  transform: translateX(-20px);
  transition: all 0.15s ease-in-out;
}

@media (min-width: 992px) {
  .move-right:hover,
  .move-left:hover {
    transform: translateX(0);
    color: $secondary;
  }
}
</style>
